'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _labelLocal = require('./label.local.css');

var _labelLocal2 = _interopRequireDefault(_labelLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Label = function Label(props) {
  return _react2.default.createElement('label', {
    htmlFor: props.htmlFor,
    className: props.className
  }, props.text && _react2.default.createElement('span', {
    className: (0, _classnames2.default)([_labelLocal2.default.label, props.fauxLabel && _labelLocal2.default.fauxLabel])
  }, props.text), props.children);
};

Label.displayName = 'UILabel';
Label.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.any,
  htmlFor: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string,
  fauxLabel: _propTypes2.default.bool
};
exports.default = Label;